import React from "react";
import FluidAnimation from "react-fluid-animation";
import "../styles/fluid-animation.css"

const FluidAnimations = () => {
  return <FluidAnimation className="fluid_container" />;
};

export default FluidAnimations;
